{
    "policyNumber": "6700720212",
    "scheme": "r\u00e1mcove zmluvy SB, KB, banky",
    "rate": 3.3,
    "dateBegin": "2025-01-03T00:00:00.000+01:00",
    "dateEnd": "2025-01-03T00:00:00.000+01:00",
    "statusId": 5,
    "statusLabel": "stornovan\u00e1",
    "premium": 3.3,
    "tariff": "1OB",
    "groupPolicyNumber": "6690076424",
    "zone": "A",
    "groupDateBegin": "2017-01-01T00:00:00.000+01:00",
    "groupDateEnd": null,
    "partner": {
        "firstName": "Test\u00edk",
        "surname": "Testovi\u010d",
        "dateOfBirth": "2000-12-18T00:00:00.000+01:00"
    }
}